import { Box, Paper, Stack, Title } from "@mantine/core";
import React from "react";
import { usePingQuery } from "../../../../openapi";

export const IntegrationsHealthChecker: React.FC = () => {
  // const {
  //   data: azureFunctionsAPIPing,
  //   error: azureFunctionsAPIPingError,
  //   isLoading: azureFunctionsAPIPingLoading,
  //   isSuccess: azureFunctionsAPIPingSuccess,
  // } = usePingMCappsAzureFunctionsQuery();

  const { data: pingTrpc, error: trpcPingError, isSuccess: trpcSuccess } = usePingQuery();

  const listItems = [
    // {
    //   name: "Azure Functions API",
    //   isSuccess: azureFunctionsAPIPingError == null && azureFunctionsAPIPingSuccess === true,
    // },
    {
      name: "TRPC API",
      isSuccess: trpcPingError == null && trpcSuccess === true,
    },
  ];

  console.log(pingTrpc?.ping);

  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Integrationer
        </Title>
        <Stack gap="xs">
          {listItems.map((item) => (
            <Box
              key={item.name}
              style={{
                border: "1px solid",
                borderColor: item.isSuccess ? "#c3e6cb" : "#f5c6cb",
                backgroundColor: item.isSuccess ? "#d4edda" : "#f8d7da",
                borderRadius: "0.25rem",
                padding: "0.5rem 0.75rem",
              }}
            >
              {item.name}
            </Box>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
};
